export const adminImgURL = '/img/admin_avatar.avif';
export const userImgURL = '/img/user_avatar.avif';
